import { BUSINESS_UNIT } from '../constants';
import { getTopLevelDomain } from '../location';
import { GetSiteTenant } from './types';

export const getBusinessUnitFromDomain = () => {
  const topLevelDomain = getTopLevelDomain();
  let businessUnitFromDomain = BUSINESS_UNIT.SO;
  Object.values(BUSINESS_UNIT).forEach((businessUnitConfig) => {
    if (!topLevelDomain.includes(businessUnitConfig.name)) {
      return;
    }
    businessUnitFromDomain = businessUnitConfig;
  });
  return businessUnitFromDomain;
};

export const getSiteTenant = (currentTenant: string): GetSiteTenant => {
  const shortTenant = currentTenant.substring(2).toLowerCase();
  const { code: businessUnitCode } = getBusinessUnitFromDomain();
  return {
    businessUnit: businessUnitCode.toUpperCase(),
    tenant: shortTenant,
    siteId: `${businessUnitCode}${shortTenant}`,
  };
};
